import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center w-full" }
const _hoisted_2 = { class: "flex gap-2.5 items-center justify-start" }
const _hoisted_3 = { class: "flex gap-2 items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CourierShuttleSelector = _resolveComponent("CourierShuttleSelector")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        class: "w-full mr-0",
        style: {"margin-right":"0","width":"230px"},
        placeholder: "No. Shipment/STT/DEM",
        value: _ctx.searchValue,
        onInput: _ctx.onSearch,
        onClear: _ctx.onClearSearch
      }, null, 8, ["value", "onInput", "onClear"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_CourierShuttleSelector, {
        selectedItem: _ctx.selectedCourierShuttle,
        "onUpdate:selectedItem": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedCourierShuttle = $event)),
        onCourierShuttleChange: _ctx.handleCourierShuttleChange,
        class: "w-64"
      }, null, 8, ["selectedItem", "onCourierShuttleChange"]),
      _createVNode(_component_lp_button, {
        title: _ctx.$t('dispatch.process'),
        "text-color": "white",
        disabled: _ctx.disabled,
        onClick: _ctx.onProcess
      }, null, 8, ["title", "disabled", "onClick"])
    ])
  ]))
}